import * as INR from "../INR.ts";
import ApiServer from "../ApiServer.js";
import {ContactCache} from "./ContactCache.js";
import {ControllerBook} from "../page/ControllerBook.js";
import CONTACTS_LIST_TEMPLATE from "../contact/contacts_list.mustache";
import CONTACT_DETAILS_TEMPLATE from "../contact/contact_details.mustache";
import TPL_RIGHT_EMPTY from "../contact/contact_empty.mustache";
import $ from "../$.js";

INR.onPage(INR.URL.CONTACTS,function(){

  async function datachanged(ctc){
    CONTROLLER.onRefresh(await ContactCache.refresh())
      
    if(ctc instanceof ApiServer.types.IContact){
      CONTROLLER.select(ctc.metaId)
    }
    
  }
  var CONTROLLER = new ControllerBook($('.pane-left'),CONTACTS_LIST_TEMPLATE,$(".pane-main"),CONTACT_DETAILS_TEMPLATE,TPL_RIGHT_EMPTY,ContactCache);
  INR.subscribe("contactCreated",datachanged);
  INR.subscribe("contactUpdated",datachanged);
  INR.subscribe("contactDeleted",datachanged);
  
  
});